import React from 'react';
import type { Supplier } from '../../../types/supplier';

interface SupplierFormProps {
  initialData?: Supplier;
  onSubmit: (data: Supplier) => Promise<void>;
  isSubmitting: boolean;
  error: string | null;
  onCancel: () => void;
  submitLabel: string;
}

export default function SupplierForm({
  initialData,
  onSubmit,
  isSubmitting,
  error,
  onCancel,
  submitLabel
}: SupplierFormProps) {
  const [formData, setFormData] = React.useState<Supplier>({
    suppl_abrev: initialData?.suppl_abrev || '',
    supplier_name: initialData?.supplier_name || '',
    supplier_contact: initialData?.supplier_contact || ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-2xl">
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
      )}

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Abbreviation *
          </label>
          <input
            type="text"
            value={formData.suppl_abrev}
            onChange={(e) => setFormData(prev => ({ ...prev, suppl_abrev: e.target.value }))}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-primary focus:ring-primary"
            required
          />
          <p className="mt-1 text-sm text-gray-500">
            Enter a short abbreviation for the supplier
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Name *
          </label>
          <input
            type="text"
            value={formData.supplier_name}
            onChange={(e) => setFormData(prev => ({ ...prev, supplier_name: e.target.value }))}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-primary focus:ring-primary"
            required
          />
          <p className="mt-1 text-sm text-gray-500">
            Enter the full name of the supplier
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Contact *
          </label>
          <input
            type="text"
            value={formData.supplier_contact}
            onChange={(e) => setFormData(prev => ({ ...prev, supplier_contact: e.target.value }))}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-primary focus:ring-primary"
            required
          />
          <p className="mt-1 text-sm text-gray-500">
            Enter the contact information for the supplier
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-primary-dark disabled:opacity-50"
        >
          {isSubmitting ? 'Submitting...' : submitLabel}
        </button>
      </div>
    </form>
  );
}
